import { apolloClient } from '~/apollo-client';
import {
  Flex_DeleteBillUploadMutation,
  Flex_DeleteBillUploadMutationVariables,
} from '~/typings/graphql';
import { DELETE_BILL_UPLOAD } from './upload-bill-images.queries';

export type DeleteBillUploadParams = {
  id: number;
};

export type DeleteBillUploadResponse = {
  id: number;
};

export const deleteBillUpload = async ({
  id,
}: DeleteBillUploadParams): Promise<DeleteBillUploadResponse> => {
  const response = await apolloClient.mutate<
    Flex_DeleteBillUploadMutation,
    Flex_DeleteBillUploadMutationVariables
  >({
    mutation: DELETE_BILL_UPLOAD,
    variables: { id },
  });

  return { id: response.data?.deleteBillUpload.id! };
};
